<template>
    <v-container fluid class="mx-0 px-3"> </v-container>
</template>

<script>
export default {
    name: "Admin",
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>
